<template>
  <div v-if="isLoading" class="title-bar">
    <b-form>
      <br><br><br><br><br>

      <h5 class="loading-text">
        loading
      </h5>

      <br>

      <b-spinner
        class="loading-spinner"
        variant="warning"
      />
    </b-form>
  </div>

  <div v-else class="main">

    <!-- Hero section -->
    <b-row no-gutters>
      <b-col cols="12" class="hero-column">

        <div class="login-picture">

          <!-- Photography credit -->
          <div class="photography">
            <p>photography : tim mossholder</p>
          </div>

          <!-- Language selector -->
          <div class="language">
            <b-dropdown
              left
              split
              text="language"
              class="language-dropdown-white"
              toggle-class="toggle-language-white"
              split-class="split-language-white"
              size="sm"
            >
              <template #button-content>
                <img
                  :src="currentLanguageFlag"
                  class="current-language-flag"
                  alt="Selected language"
                >
              </template>

              <b-dropdown-item @click="selectLanguage('en')">
                <img
                  :src="require('@/assets/img/flags/english.png')"
                  class="language-flag"
                  alt="English"
                >
                English
              </b-dropdown-item>

              <b-dropdown-item @click="selectLanguage('fr')">
                <img
                  :src="require('@/assets/img/flags/francais.png')"
                  class="language-flag"
                  alt="Français"
                >
                Français (French)
              </b-dropdown-item>

              <b-dropdown-item @click="selectLanguage('de')">
                <img
                  :src="require('@/assets/img/flags/deutsch.png')"
                  class="language-flag"
                  alt="Deutsch"
                >
                Deutsch (German)
              </b-dropdown-item>

              <b-dropdown-item @click="selectLanguage('es')">
                <img
                  :src="require('@/assets/img/flags/spanish.png')"
                  class="language-flag"
                  alt="Español"
                >
                Español (Spanish)
              </b-dropdown-item>

              <b-dropdown-item @click="selectLanguage('it')">
                <img
                  :src="require('@/assets/img/flags/italian.png')"
                  class="language-flag"
                  alt="Italiano"
                >
                Italiano (Italian)
              </b-dropdown-item>

              <b-dropdown-item @click="selectLanguage('nl')">
                <img
                  :src="require('@/assets/img/flags/dutch.png')"
                  class="language-flag"
                  alt="Nederlands"
                >
                Nederlands (Dutch)
              </b-dropdown-item>

              <b-dropdown-item @click="selectLanguage('pt')">
                <img
                  :src="require('@/assets/img/flags/portuguese.png')"
                  class="language-flag"
                  alt="Português"
                >
                Português (Portuguese)
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <!-- Main title -->
          <div class="login-overlay">
            <h1 class="main-title">
              <strong class="wyne-title">WYNE</strong>LOVER
            </h1>

            <p class="main-subtitle">
              {{ translate("the open digital wine ecosystem") }}
            </p>
          </div>

          <!-- Social media -->
          <div class="social-media">
            <b-img
              class="social-icon"
              :src="require('@/assets/img/facebook-white.png')"
              alt="Facebook"
              @click="gotoFacebook"
            />

            <b-img
              class="social-icon"
              :src="require('@/assets/img/instagram-white.png')"
              alt="Instagram"
              @click="gotoInstagram"
            />
          </div>

          <!-- Copyright -->
          <div class="copyright">
            <p>
              {{
                translate(
                  "funware for wine lovers developed and © copyrighted by"
                )
              }}
            </p>
            <p>
              {{
                translate(
                  "N'JOY Information Technology"
                )
              }}
            </p>
          </div>

        </div>
      </b-col>
    </b-row>

    <!-- About WyneLover -->
    <b-row
      no-gutters
      class="click-box w-cursor-click"
      @click="onAboutUs"
    >
      <div class="home-picture">
        <div class="box-overlay">
          <p class="box-text">
            {{ translate("who we are, what we do") }}
          </p>
        </div>
      </div>
    </b-row>

    <!-- WyneCellar -->
    <b-row
      no-gutters
      class="click-box w-cursor-click"
      @click="onWyneCellar"
    >
      <div class="wynecellar-picture">
        <div class="box-overlay">
          <p class="box-text">
            {{ translate("for wine collectors") }}
          </p>
        </div>
      </div>
    </b-row>

    <!-- WyneTaster -->
    <b-row
      no-gutters
      class="click-box w-cursor-click"
      @click="onWyneTaster"
    >
      <div class="wynetaster-picture">
        <div class="box-overlay">
          <p class="box-text">
            {{ translate("for wine tasting events") }}
          </p>
        </div>
      </div>
    </b-row>

    <!-- WyneMaker -->
    <b-row
      no-gutters
      class="click-box w-cursor-click"
      @click="onWyneMaker"
    >
      <div class="wynemaker-picture">
        <div class="box-overlay">
          <p class="box-text">
            {{ translate("for wine producers") }}
          </p>
        </div>
      </div>
    </b-row>

  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { translate_word } from '../assets/js/translate.js'

export default {
  name: 'Index',

  computed: {
    currentLanguage() {
      return this.$store.state.language
    },

    currentLanguageFlag() {
      const flags = {
        en: require('@/assets/img/flags/english.png'),
        fr: require('@/assets/img/flags/francais.png'),
        de: require('@/assets/img/flags/deutsch.png'),
        es: require('@/assets/img/flags/spanish.png'),
        it: require('@/assets/img/flags/italian.png'),
        nl: require('@/assets/img/flags/dutch.png'),
        pt: require('@/assets/img/flags/portuguese.png')
      }

      return flags[this.currentLanguage] || flags.en
    }
  },

  data() {
    return {
      language: 'en',
      isLoading: true
    }
  },

  mounted() {
    let language = Cookies.get('wynelover.language')

    const supportedLanguages = [
      'en',
      'fr',
      'de',
      'es',
      'it',
      'nl',
      'pt'
    ]

    if (!supportedLanguages.includes(language)) {
      language = 'en'
    }

    this.selectLanguage(language)
    this.isLoading = false
  },

  methods: {
    onAboutUs() {
      this.$router.push({
        path: '/AboutUs'
      })
    },

    onWyneMaker() {
      window.open(
        'https://www.wynemaker.com',
        '_blank',
        'noopener,noreferrer'
      )
    },

    onWyneCellar() {
      window.open(
        'https://www.wynecellar.com',
        '_blank',
        'noopener,noreferrer'
      )
    },

    onWyneTaster() {
      window.open(
        'https://www.wynetaster.com',
        '_blank',
        'noopener,noreferrer'
      )
    },

    gotoFacebook() {
      window.open(
        'https://www.facebook.com/wynelover.eu',
        '_blank',
        'noopener,noreferrer'
      )
    },

    gotoInstagram() {
      window.open(
        'https://www.instagram.com/wyne.lover/',
        '_blank',
        'noopener,noreferrer'
      )
    },

    selectLanguage(language) {
      const supportedLanguages = [
        'en',
        'fr',
        'de',
        'es',
        'it',
        'nl',
        'pt'
      ]

      const selectedLanguage = supportedLanguages.includes(language)
        ? language
        : 'en'

      this.language = selectedLanguage
      this.$store.commit('setLanguage', selectedLanguage)

      Cookies.set(
        'wynelover.language',
        selectedLanguage,
        {
          expires: 365,
          path: '/'
        }
      )
    },

    translate(string) {
      return translate_word(string, this.currentLanguage)
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
}

.hero-column {
  height: 40vh;
  padding: 0 !important;
}

.login-picture {
  position: relative;

  width: 100%;
  height: 40vh;

  background-image: url("../assets/img/wynelover.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  border-bottom: 5px solid white;
  overflow: visible;
}

/* Language selector */

.language {
  position: absolute;
  top: 5px;
  left: 5px;

  color: white;
  z-index: 10000;
}

.current-language-flag {
  display: block;
  width: 28px;
  height: 19px;

  object-fit: cover;
  border-radius: 2px;
}

.language-flag {
  width: 37px;
  height: 25px;
  margin-right: 7px;

  object-fit: cover;
  vertical-align: middle;
}

.language ::v-deep .dropdown-menu {
  z-index: 10001 !important;
}

/* Photography credit */

.photography {
  position: absolute;
  top: 7px;
  right: 8px;

  color: rgba(255, 255, 255, 0.75);
  font-size: 9px;
  line-height: 1;

  z-index: 5;
}

.photography p {
  margin: 0;
}

/* Main title */

.login-overlay {
  position: absolute;
  top: 48%;
  left: 50%;

  width: calc(100% - 30px);

  text-align: center;
  transform: translate(-50%, -50%);

  z-index: 4;
}

.main-title {
  margin: 0;

  color: white !important;
  font-size: clamp(34px, 10vw, 48px) !important;
  line-height: 1.05;
  text-align: center;

  white-space: nowrap;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.65);
}

.wyne-title {
  color: rgb(195, 147, 130);
}

.main-subtitle {
  max-width: 340px;
  margin: 5px auto 0;

  color: white;
  font-size: clamp(13px, 4vw, 18px) !important;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;

  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.9);
}

/* Social media */

.social-media {
  position: absolute;
  left: 50%;
  bottom: 31px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;

  transform: translateX(-50%);
  z-index: 5;
}

.social-icon {
  display: block;

  width: 25px;
  height: 25px;

  object-fit: contain;
  cursor: pointer;
}

/* Copyright */

.copyright {
  position: absolute;
  right: 4px;
  bottom: 5px;
  left: 4px;

  color: white;
  font-size: clamp(7px, 2vw, 10px) !important;
  line-height: 1.1;
  text-align: center;

  text-shadow: 0 1px 3px rgba(0, 0, 0, 1);

  z-index: 5;
}

.copyright p {
  margin: 0;
}

/* Navigation image sections */

.home-picture,
.wynecellar-picture,
.wynetaster-picture,
.wynemaker-picture {
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 20vh;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  border-bottom: 5px solid white;
}

.home-picture {
  background-image: url("../assets/img/home.jpg");
}

.wynecellar-picture {
  background-image: url("../assets/img/wynecellar.png");
}

.wynetaster-picture {
  background-image: url("../assets/img/wynetaster.png");
}

.wynemaker-picture {
  background-image: url("../assets/img/wynemaker.jpg");
}

.box-overlay {
  position: relative;

  width: 100%;
  padding: 0 15px;

  text-align: center;
  z-index: 2;
}

.box-text {
  margin: 0;

  color: white;
  font-size: clamp(16px, 4.5vw, 23px) !important;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;

  text-shadow:
    0 2px 3px rgba(0, 0, 0, 1),
    0 0 8px rgba(0, 0, 0, 0.65);
}

.click-box {
  width: 100%;
  margin: 0 !important;

  display: flex;
  justify-content: center;
  align-items: center;
}

.w-cursor-click {
  cursor: pointer;
}

/* Loading screen */

.title-bar {
  min-height: 100vh;

  text-align: center;
  background-color: #1f1f1f;
}

.loading-text {
  color: white;
}

.loading-spinner {
  color: rgb(109, 122, 82) !important;
}

/* Very narrow phones */

@media (max-width: 360px) {
  .main-title {
    font-size: 31px !important;
  }

  .main-subtitle {
    max-width: 280px;
    font-size: 13px !important;
  }

  .social-media {
    bottom: 33px;
  }

  .social-icon {
    width: 22px;
    height: 22px;
  }

  .photography {
    max-width: 145px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>